export function waitForSuccessfulResponse(url, timeout) {
    if (timeout === void 0) { timeout = 45000; }
    var timeoutTimestamp = Date.now() + timeout;
    var withRetry = function (invoke, resolve, reject) {
        invoke()
            .then(resolve)
            .catch(function () {
            setTimeout(function () {
                if (Date.now() < timeoutTimestamp) {
                    withRetry(invoke, resolve, reject);
                }
                else {
                    reject();
                }
            }, 1000);
        });
    };
    return Promise.race([
        new Promise(function (res, rej) {
            return withRetry(function () { return fetch(url).then(function (r) { return (r.status < 400 ? r : Promise.reject(r)); }); }, res, rej);
        }),
        new Promise(function (res) { return setTimeout(res, timeout); }),
    ]);
}
//# sourceMappingURL=waitForSuccessfulResponse.js.map